import fetchAPI from './fetchAPI';

const PAGE_SIZE = 40;

function requestPage(route, options, page) {
  return new Promise((resolve, reject) => {
    if (route.indexOf('limit=') !== -1 || route.indexOf('offset=') !== -1) {
      return reject(
        "Can't use fetchAll when the route already has limit or offset"
      );
    }
    let pageSize = PAGE_SIZE;
    if (options.pageSize) {
      pageSize = options.pageSize;
    }
    if (route.indexOf('?') === -1) {
      route += '?';
    } else {
      route += '&';
    }
    route += 'limit=' + pageSize + '&offset=' + page * pageSize;
    fetchAPI(route, options).then(data => {
      resolve(data);
    }).catch(e => {
      return reject(e);      
    });
  });
}

function requestAllPages(route, options) {
  return new Promise((resolve, reject) => {
    var allData, allResults, ended, oneResponse, pageNumber;
    let pageSize = PAGE_SIZE;
    if (options.pageSize) {
      pageSize = options.pageSize;
    }
    allData = {};
    allResults = [];
    ended = false;
    pageNumber = 0;
    (async () => {
      while (!ended) {
        try {
          oneResponse = await requestPage(route, options, pageNumber);
        } catch (e) {
          return reject(e);
        }
        if (oneResponse && oneResponse.results) {
          allResults = allResults.concat(oneResponse.results);
        }
        if (
          !oneResponse ||
          !oneResponse.results ||
          oneResponse.results.length < pageSize
        ) {
          allData = oneResponse || {};
          allData.results = allResults;
          ended = true;
          resolve(allData);
        }
        pageNumber++;
      }
    })();
  });
}

export default function fetchAll(route, options = {}) {
  return requestAllPages(route, options);
}
